<template>
  <div class="ebayorder">
    <h1 class="subheading grey--text">Create Ebay Order</h1>

    <v-container class="my-5">
      <v-text-field
        v-model="searchTerm"
        @keyup="doFilter"
        label="Enter eBay item number or cart item"
        prepend-icon="search"
        clearable
      ></v-text-field>

      <v-layout row wrap>
        <v-flex
          xs12
          sm6
          md4
          lg3
          v-for="ebayItem in ebayItems"
          :key="ebayItem.id"
        >
          <v-card class="text-xs-center ma-3">
            <v-card-text>
              <div class="subheading">{{ ebayItem.ebayItem }}</div>
            </v-card-text>
            <v-card-text>
              <div class="grey--text">{{ ebayItem.ebayModel }}</div>
            </v-card-text>
            <v-card-text>
              <div class="grey--text">{{ ebayItem.itemList }}</div>
            </v-card-text>
            <v-card-actions>
              <EbayOrderDialog
                v-bind:ebayItem="ebayItem.ebayItem"
                v-bind:ebayModel="ebayItem.ebayModel"
                @orderConfirmed="snackbar = true"
              />
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import cartApi from "../modules/cart-api";
import EbayOrderDialog from "../components/EbayOrderDialog";

export default {
  components: { EbayOrderDialog },
  data() {
    return {
      searchTerm: "",
      ebayItemsRaw: [],
      ebayItems: []
    };
  },
  created() {
    this.getEbayItemList();
  },
  methods: {
    async getEbayItemList() {
      this.ebayItemsRaw = await cartApi.getEbayItems();
      await this.doFilter();
    },
    async doFilter() {
      if (!this.searchTerm || this.searchTerm.length == 0) {
        this.ebayItems = this.ebayItemsRaw;  
      } else {
        this.ebayItems = this.ebayItemsRaw.filter(
          item => item.ebayItem.includes(this.searchTerm) ||
                  item.itemList.includes(this.searchTerm));
        }
    }
  }
};
</script>
